import { createStyles, Theme } from '@material-ui/core';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    pulldown: {
      display: 'flex',
      alignItems: 'bottom',
      marginBottom: '0 !important',
    },
    field: {
      marginBottom: '0 !important',
    },
    notes: {
      marginTop: '0 !important',
      marginBottom: spacing(4),
    },
    add: {
      marginTop: spacing(-4),
    },
    delete: {
      marginBottom: spacing(-2),
    },
  });
